import React from 'react';
import Main from '../AboutUs/Main'
import MainSec2 from '../AboutUs/MainSec2';

export const AboutUs = () => {
  return (
    <>
        <Main />
        <MainSec2 />
    </>
  );
};